/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-03-02 16:21:28
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { ICellCard } from './types';

const CellCard = ({ children, marginTop, marginBottom }: ICellCard) => {
  return (
    <div style={{ marginTop, marginBottom }} className="cell-card">
      {children}
    </div>
  );
};

export default CellCard;
